import AppConfig from "util/AppConfig";
const useNavigationCustomization = () => {
  var _a, _b, _c;
  return (_c = (_b = (_a = AppConfig).branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.navigation;
};
export default useNavigationCustomization;
